export default __webpack_public_path__ + "static/media/quokkas.d2e50659.mp3";